import { gql } from "@apollo/client";

export default gql`
  mutation saveComplianceProgramReportingView(
    $complianceProgramId: Int!
    $assessmentType: AssessmentType!
    $name: String!
    $viewOptions: String!
    $id: Int
  ) {
    createOrUpdateComplianceProgramReportingView(
      complianceProgramId: $complianceProgramId
      assessmentType: $assessmentType
      name: $name
      viewOptions: $viewOptions
      id: $id
    ) {
      complianceProgramReportingView {
        id
        name
        viewOptions
      }
    }
  }
`;
